import React from 'react'
import './family-info-gutter.css'
import ContactInfoTab from './ContactInfoTab/ContactInfoTab'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { getRequestHeaders } from '../../api'
import { MdAutoAwesome } from 'react-icons/md'

const FamilyInfoGutter = ({
    modalInfo,
    setModalInfo,
    setCopyConfirmationPopup,
    setFamilyProfile,
    teachers = [],
    onOpenScheduler,
}) => {
    const [familyInfo, setFamilyInfo] = React.useState(null)
    const [loadingFamilyInfo, setLoadingFamilyInfo] = React.useState(true)
    const [hookUpFamily, setHookUpFamily] = React.useState(true)
    const [familyLoadError, setFamilyLoadError] = React.useState('')
    const [scheduledEvents, setScheduledEvents] = React.useState([])

    const getFamilyInfo = React.useCallback(async () => {
        setLoadingFamilyInfo(true)
        setFamilyLoadError('')
        setFamilyInfo(null)
        setFamilyProfile(false)
        setScheduledEvents([])

        if(!modalInfo.familyId || modalInfo.familyId === 'none') {
            setHookUpFamily(true)
            setLoadingFamilyInfo(false)
        } else {
            setHookUpFamily(false)

            const calendarRequest = axios
                .get(`${baseUrl}/calendar/family/${modalInfo.familyId}`, getRequestHeaders())
                .then((res) => {
                    setScheduledEvents(Array.isArray(res.data) ? res.data : [])
                })
                .catch((err) => {
                    console.error('Unable to load this family\'s calendar events:', err)
                    setScheduledEvents([])
                })

            const familyRequest = axios
                .get(`${baseUrl}/school-management/${modalInfo.familyId}`, getRequestHeaders())
                .then((res) => {
                    const family = res.data || null
                    setFamilyProfile(family || false)
                    setFamilyInfo(family)
                })
                .catch((err) => {
                    console.error('Unable to load the family connected to this card:', err)
                    setFamilyLoadError(
                        'The connected family could not be loaded. You can retry or connect this card to another family.'
                    )
                })

            await Promise.all([calendarRequest, familyRequest])
            setLoadingFamilyInfo(false)
        }
    }, [modalInfo.familyId, setFamilyProfile])

    React.useEffect(() => {
        axios.get(`${baseUrl}/teacher-invitations/${modalInfo.familyId}`)
        .catch((err) => console.log(err))

        getFamilyInfo()
    }, [getFamilyInfo, modalInfo.familyId])

    return (
        <div className='family-info-gutter'>
            <button
                type='button'
                className='family-info-gutter__scheduler-button'
                disabled={loadingFamilyInfo || !familyInfo}
                title={!loadingFamilyInfo && !familyInfo ? 'Connect this card to a family first' : ''}
                onClick={() => onOpenScheduler && onOpenScheduler()}
            >
                <MdAutoAwesome size={16} aria-hidden='true' />
                Scheduler
            </button>
            <ContactInfoTab
                modalInfo={modalInfo}
                setModalInfo={setModalInfo}
                setCopyConfirmationPopup={setCopyConfirmationPopup}
                familyInfo={familyInfo}
                loadingFamilyInfo={loadingFamilyInfo}
                hookUpFamily={hookUpFamily}
                familyLoadError={familyLoadError}
                scheduledEvents={scheduledEvents}
                getFamilyInfo={getFamilyInfo}
                teachers={teachers}
            />
        </div>
    )
}
export default FamilyInfoGutter
